<!--支付成功-->
<template>
  <div class="order-over">
    <van-icon class="success-btn" name="passed" color="#f90" size="100" />
    <div style='font-size:20px;color: #323233;'>购买成功</div>
    <div class="btn-box">
      <van-button class="btn-item" @click="gotoHome">返回首页</van-button>
      <van-button class="btn-item" @click="gotoOrderDetail">查看订单</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderNum: '',
    };
  },
  created() {
    this.orderNum = this.$route.query.orderNum;
  },
  methods: {
    gotoOrderDetail() {
      /*api.getOrderDetail({ orders: this.orderNum }).then(res => {
        console.log(res);
      });*/
      this.$router.replace({
        name: 'order',
      });
    },
    gotoHome() {
      this.$router.replace({
        name: 'home'
      })
    }
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.order-over {
  width: 100vw;
  height: 100vh;
  text-align: center;
  .title {
    font-size: 16px;
    margin-top: 5px;
    border-bottom: 1px solid $light-line-color;
  }
  .success-btn {
    display: inline-block;
    width: 100vw;
    margin-top: 20vh;
  }
  .btn-box {
    display: flex;
    margin: 20px auto;
    width: 90vw;
    justify-content: space-around;
    .btn-item {
      width: 40%;
    }
  }
}
</style>
